// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar_navbar-landscape__nlbnt {
  position: sticky;
  top: 0;
  background-color: var(--background-color-2);
  width: 100%;
  height: var(--navbar-height);
  color: black;
  z-index: 1001;
  transition: transform 0.3s ease;
  border-bottom: 1px solid var(--light-grey);
  box-shadow: 0 2px 2px rgba(63, 92, 110, 0.1490196078);
}
.Navbar_navbar-landscape__nlbnt.Navbar_white-theme__57nC7 {
  background-color: transparent;
  border-bottom: none;
}
.Navbar_navbar-landscape__nlbnt.Navbar_white-theme__57nC7 .Navbar_item_menu__hC7WS {
  height: 50px;
  color: white;
  border-radius: 10px;
  padding: 10px;
}
.Navbar_navbar-landscape__nlbnt.Navbar_white-theme__57nC7 .Navbar_item_menu__hC7WS:hover {
  border-bottom: none;
}
.Navbar_navbar-landscape__nlbnt.Navbar_white-theme__57nC7 .Navbar_item_menu__hC7WS.Navbar_selected__U\\+Cb5 {
  color: white;
  border-bottom: none;
  background-color: var(--explore-color);
}
.Navbar_navbar-landscape__nlbnt.Navbar_hide__rVRTO {
  transform: translateY(-100%);
}
.Navbar_navbar-landscape__nlbnt .Navbar_container__1gqf2 {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ {
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ .Navbar_logo__D9AsY {
  margin-right: 80px;
  height: 90%;
}
.Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ .Navbar_menu__xVJ8F {
  font-size: 18px;
  display: flex;
  height: 100%;
}
.Navbar_navbar-landscape__nlbnt .Navbar_right__l\\+3q3 {
  display: flex;
  gap: 12px;
}
.Navbar_navbar-landscape__nlbnt .Navbar_ant-select__AhzXU {
  width: 100%;
}
.Navbar_navbar-landscape__nlbnt .Navbar_ant-select-selector__Yhunc {
  height: 100%;
}
@media only screen and (max-width: 900px) {
  .Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }
  .Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ .Navbar_logo__D9AsY {
    margin: 0 !important;
  }
  .Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ .Navbar_menu__xVJ8F .Navbar_item_menu__hC7WS {
    margin-left: 40px;
    margin-right: 0 !important;
  }
  .Navbar_navbar-landscape__nlbnt .Navbar_left__HkupQ .Navbar_menu__xVJ8F .Navbar_item_menu__hC7WS svg {
    width: 25px;
    height: 25px;
  }
}

.Navbar_drawer__\\+HRdZ {
  display: flex;
  flex-direction: column;
}
.Navbar_drawer__header__u3ARK {
  padding: 0 16px !important;
}
.Navbar_drawer__header__u3ARK svg {
  color: var(--explore-color);
}
.Navbar_drawer__body__d-z91 {
  padding: 0 !important;
}

.Navbar_logo-container__OuOeF {
  height: var(--navbar-height);
  display: flex;
  align-items: center;
}
.Navbar_logo-container__OuOeF img {
  height: 75%;
}

.Navbar_item_menu__hC7WS {
  height: 100%;
  cursor: pointer;
  margin-right: 32px;
  font-size: 12px;
  display: flex;
  align-items: center;
  position: relative;
}
.Navbar_item_menu__hC7WS svg {
  margin-right: 5px;
}
.Navbar_item_menu__hC7WS.Navbar_selected__U\\+Cb5 {
  color: var(--explore-color);
  border-bottom: 3px solid var(--explore-color);
  font-weight: 700;
}
.Navbar_item_menu__hC7WS:hover {
  border-bottom: 3px solid var(--explore-color);
}
.Navbar_item_menu--parent__szllM .Navbar_item_menu__dropdown__TP3zR {
  display: none;
}
.Navbar_item_menu--parent__szllM:hover .Navbar_item_menu__dropdown__TP3zR {
  display: flex;
}
.Navbar_item_menu--parent__szllM .Navbar_item_menu--arrow__avJYQ {
  transition: transform 0.2s;
}
.Navbar_item_menu--parent__szllM:hover .Navbar_item_menu--arrow__avJYQ {
  transform: rotate(180deg);
}
.Navbar_item_menu__dropdown__TP3zR {
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 220px;
  flex-direction: column;
  background: var(--background-color-2);
  border: 1px solid var(--light-grey);
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 6px 0;
  z-index: 10;
}
.Navbar_item_menu__dropdown-item__OHXnH {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-1);
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.15s;
}
.Navbar_item_menu__dropdown-item__OHXnH:hover {
  background: rgba(0, 0, 0, 0.04);
}
.Navbar_item_menu__dropdown-item__OHXnH.Navbar_selected__U\\+Cb5 {
  color: var(--explore-color);
  font-weight: 700;
}
.Navbar_item_menu__dropdown-item__OHXnH svg {
  flex-shrink: 0;
}
@media only screen and (max-width: 900px) {
  .Navbar_item_menu__hC7WS {
    padding: 12px 20px;
    width: calc(100% - 24px);
    margin: 0 0 0 12px !important;
    font-size: 14px;
    font-weight: normal;
    border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  }
  .Navbar_item_menu__hC7WS.Navbar_selected__U\\+Cb5 {
    color: var(--explore-color);
    font-weight: bold;
    border-bottom: 1px solid var(--explore-color);
  }
  .Navbar_item_menu__hC7WS svg {
    width: 14px;
    height: 14px;
    margin-right: 0 8px;
  }
  .Navbar_item_menu--parent__szllM {
    flex-wrap: wrap;
  }
  .Navbar_item_menu--parent__szllM .Navbar_item_menu__dropdown__TP3zR {
    display: flex;
    position: static;
    width: 100%;
    box-shadow: none;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-top: 4px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Layout/Navbar/Navbar.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,MAAA;EACA,2CAAA;EACA,WAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,0CAAA;EACA,qDAAA;AACF;AACE;EACE,6BAAA;EACA,mBAAA;AACJ;AAAI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAEN;AADM;EACE,mBAAA;AAGR;AADM;EACE,YAAA;EACA,mBAAA;EACA,sCAAA;AAGR;AAEE;EACE,4BAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAIE;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAFJ;AAII;EACE,kBAAA;EACA,WAAA;AAFN;AAKI;EACE,eAAA;EACA,aAAA;EACA,YAAA;AAHN;AAOE;EACE,aAAA;EACA,SAAA;AALJ;AAQE;EACE,WAAA;AANJ;AASE;EACE,YAAA;AAPJ;AAUE;EACE;IACE,WAAA;IACA,aAAA;IACA,2BAAA;EARJ;EAUI;IACE,oBAAA;EARN;EAYM;IACE,iBAAA;IACA,0BAAA;EAVR;EAYQ;IACE,WAAA;IACA,YAAA;EAVV;AACF;;AAiBA;EACE,aAAA;EACA,sBAAA;AAdF;AAiBE;EACE,0BAAA;AAfJ;AAiBI;EACE,2BAAA;AAfN;AAmBE;EACE,qBAAA;AAjBJ;;AAqBA;EACE,4BAAA;EACA,aAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,WAAA;AAlBJ;;AAsBA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAnBF;AAqBE;EACE,iBAAA;AAnBJ;AAsBE;EACE,2BAAA;EACA,6CAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,6CAAA;AArBJ;AA0BI;EACE,aAAA;AAxBN;AA2BI;EACE,aAAA;AAzBN;AA6BI;EACE,0BAAA;AA3BN;AA8BI;EACE,yBAAA;AA5BN;AAgCE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,sBAAA;EACA,qCAAA;EACA,mCAAA;EACA,kBAAA;EACA,yCAAA;EACA,cAAA;EACA,WAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BAAA;AA9BN;AAgCM;EACE,+BAAA;AA9BR;AAiCM;EACE,2BAAA;EACA,gBAAA;AA/BR;AAkCM;EACE,cAAA;AAhCR;AAqCE;EAnFF;IAoFI,kBAAA;IACA,wBAAA;IACA,6BAAA;IACA,eAAA;IACA,mBAAA;IACA,4CAAA;EAlCF;EAoCE;IACE,2BAAA;IACA,iBAAA;IACA,6CAAA;EAlCJ;EAqCE;IACE,WAAA;IACA,YAAA;IACA,mBAAA;EAnCJ;EAuCE;IACE,eAAA;EArCJ;EAuCI;IACE,aAAA;IACA,gBAAA;IACA,WAAA;IACA,gBAAA;IACA,YAAA;IACA,gBAAA;IACA,UAAA;IACA,eAAA;EArCN;AACF","sourcesContent":[".navbar-landscape {\n  position: sticky;\n  top: 0;\n  background-color: var(--background-color-2);\n  width: 100%;\n  height: var(--navbar-height);\n  color: black;\n  z-index: 1001;\n  transition: transform 0.3s ease;\n  border-bottom: 1px solid var(--light-grey);\n  box-shadow: 0 2px 2px #3f5c6e26;\n\n  &.white-theme {\n    background-color: transparent;\n    border-bottom: none;\n    .item_menu {\n      height: 50px;\n      color: white;\n      border-radius: 10px;\n      padding: 10px;\n      &:hover {\n        border-bottom: none;\n      }\n      &.selected {\n        color: white;\n        border-bottom: none;\n        background-color: var(--explore-color);\n      }\n    }\n  }\n\n  &.hide {\n    transform: translateY(-100%);\n  }\n\n  .container {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .left {\n    height: 100%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n\n    .logo {\n      margin-right: 80px;\n      height: 90%;\n    }\n\n    .menu {\n      font-size: 18px;\n      display: flex;\n      height: 100%;\n    }\n  }\n\n  .right {\n    display: flex;\n    gap: 12px;\n  }\n\n  .ant-select {\n    width: 100%;\n  }\n\n  .ant-select-selector {\n    height: 100%;\n  }\n\n  @media only screen and (max-width: 900px) {\n    .left {\n      width: 100%;\n      display: flex;\n      justify-content: flex-start;\n\n      .logo {\n        margin: 0 !important;\n      }\n\n      .menu {\n        .item_menu {\n          margin-left: 40px;\n          margin-right: 0 !important;\n\n          svg {\n            width: 25px;\n            height: 25px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.drawer {\n  display: flex;\n  flex-direction: column;\n  // gap: 12px;\n\n  &__header {\n    padding: 0 16px !important;\n\n    svg {\n      color: var(--explore-color);\n    }\n  }\n\n  &__body {\n    padding: 0 !important;\n  }\n}\n\n.logo-container {\n  height: var(--navbar-height);\n  display: flex;\n  align-items: center;\n\n  img {\n    height: 75%;\n  }\n}\n\n.item_menu {\n  height: 100%;\n  cursor: pointer;\n  margin-right: 32px;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  svg {\n    margin-right: 5px;\n  }\n\n  &.selected {\n    color: var(--explore-color);\n    border-bottom: 3px solid var(--explore-color);\n    font-weight: 700;\n  }\n\n  &:hover {\n    border-bottom: 3px solid var(--explore-color);\n  }\n\n  // parent items with children\n  &--parent {\n    .item_menu__dropdown {\n      display: none;\n    }\n\n    &:hover .item_menu__dropdown {\n      display: flex;\n    }\n\n    // rotate arrow on hover\n    .item_menu--arrow {\n      transition: transform 0.2s;\n    }\n\n    &:hover .item_menu--arrow {\n      transform: rotate(180deg);\n    }\n  }\n\n  &__dropdown {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    min-width: 220px;\n    flex-direction: column;\n    background: var(--background-color-2);\n    border: 1px solid var(--light-grey);\n    border-radius: 8px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    padding: 6px 0;\n    z-index: 10;\n\n    &-item {\n      display: flex;\n      align-items: center;\n      gap: 8px;\n      padding: 10px 16px;\n      font-size: 13px;\n      font-weight: 500;\n      color: var(--text-1);\n      white-space: nowrap;\n      cursor: pointer;\n      transition: background 0.15s;\n\n      &:hover {\n        background: rgba(0, 0, 0, 0.04);\n      }\n\n      &.selected {\n        color: var(--explore-color);\n        font-weight: 700;\n      }\n\n      svg {\n        flex-shrink: 0;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 900px) {\n    padding: 12px 20px;\n    width: calc(100% - 24px);\n    margin: 0 0 0 12px !important;\n    font-size: 14px;\n    font-weight: normal;\n    border-bottom: 1px solid rgba(5, 5, 5, 0.06);\n\n    &.selected {\n      color: var(--explore-color);\n      font-weight: bold;\n      border-bottom: 1px solid var(--explore-color);\n    }\n\n    svg {\n      width: 14px;\n      height: 14px;\n      margin-right: 0 8px;\n    }\n\n    // mobile: show children inline below parent\n    &--parent {\n      flex-wrap: wrap;\n\n      .item_menu__dropdown {\n        display: flex;\n        position: static;\n        width: 100%;\n        box-shadow: none;\n        border: none;\n        border-radius: 0;\n        padding: 0;\n        margin-top: 4px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navbar-landscape": `Navbar_navbar-landscape__nlbnt`,
	"white-theme": `Navbar_white-theme__57nC7`,
	"item_menu": `Navbar_item_menu__hC7WS`,
	"selected": `Navbar_selected__U+Cb5`,
	"hide": `Navbar_hide__rVRTO`,
	"container": `Navbar_container__1gqf2`,
	"left": `Navbar_left__HkupQ`,
	"logo": `Navbar_logo__D9AsY`,
	"menu": `Navbar_menu__xVJ8F`,
	"right": `Navbar_right__l+3q3`,
	"ant-select": `Navbar_ant-select__AhzXU`,
	"ant-select-selector": `Navbar_ant-select-selector__Yhunc`,
	"drawer": `Navbar_drawer__+HRdZ`,
	"drawer__header": `Navbar_drawer__header__u3ARK`,
	"drawer__body": `Navbar_drawer__body__d-z91`,
	"logo-container": `Navbar_logo-container__OuOeF`,
	"item_menu--parent": `Navbar_item_menu--parent__szllM`,
	"item_menu__dropdown": `Navbar_item_menu__dropdown__TP3zR`,
	"item_menu--arrow": `Navbar_item_menu--arrow__avJYQ`,
	"item_menu__dropdown-item": `Navbar_item_menu__dropdown-item__OHXnH`
};
export default ___CSS_LOADER_EXPORT___;
